__turbopack_context__.v({
  "board": "hero-preview-module__0zc8La__board",
  "camera": "hero-preview-module__0zc8La__camera",
  "controls": "hero-preview-module__0zc8La__controls",
  "expand": "hero-preview-module__0zc8La__expand",
  "focus": "hero-preview-module__0zc8La__focus",
  "focusLabel": "hero-preview-module__0zc8La__focusLabel",
  "heading": "hero-preview-module__0zc8La__heading",
  "narration": "hero-preview-module__0zc8La__narration",
  "numbers": "hero-preview-module__0zc8La__numbers",
  "opportunity": "hero-preview-module__0zc8La__opportunity",
  "pointer": "hero-preview-module__0zc8La__pointer",
  "reading": "hero-preview-module__0zc8La__reading",
  "selectors": "hero-preview-module__0zc8La__selectors",
  "steps": "hero-preview-module__0zc8La__steps",
  "takeaway": "hero-preview-module__0zc8La__takeaway",
  "viewport": "hero-preview-module__0zc8La__viewport",
});
